export const it = {
  // Certificate Headers
  congrats_message: "La tua installazione Wi-Fi è completa ed è stata certificata da RouteThis!",
  installation_details: "Dettagli dell'installazione",
  wireless_speed_test: "Test della velocità wireless",
  wireless_performance: "Wireless Performance",
  photos: "Fotografie",
  signal_maps: "Mappe di segnale",

  // Certificate Room Names
  singular_room: "Camera",
  room_type_bathroom: "Bagno",
  room_type_bedroom: "Camera de letto",
  room_type_dining_room: "Sala da pranzo",
  room_type_entry_or_hall: "Ingresso",
  room_type_garage: "Garage",
  room_type_kitchen: "Cucina",
  room_type_living_room: "Soggiorno",
  room_type_office: "Ufficio",
  room_type_other: "Altro",

  // Pod Name
  pod_1: "Pod Mesh",
  pod_2: "Punto di Accesso",
  pod_3: "Nodo Mesh",
  pod_4: "Modulo Mesh",
  pod_5: "Ripetitore",
  pod_6: "Pod Mesh",
  pods_1: "Pod Mesh",
  pods_2: "Punti di accesso",
  pods_3: "Nodi Mesh",
  pods_4: "Moduli Mesh",
  pods_5: "Ripetitori",
  pods_6: "Pod Mesh",

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Router",

  // Level Name
  level_1: "Livello",
  level_2: "Piani",
  levels_1: "Livelli",
  levels_2: "Piano",

  // Certificate Pod Info
  recommended: "Consigliato",
  installed: "Installato",
  total: "Totale",

  // Certificate Signal Table
  front_building: "Lato anteriore dell'edificio",
  speed: "Velocità",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Coll.",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Can.",

  // Certificate Legend
  legend: "Legenda",
  measured_speed: "Velocità misurata",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "La velocità è nell'intervallo previsto per la maggior parte dei dispositivi mobili. Non tutti i dispositivi wireless sono in grado di raggiungere la velocità massima stabilita dal piano. Vedi di seguito per i test in singole stanze.",
  speedtest_failed: "Testata su telefono o tablet. Non tutti i dispositivi wireless sono in grado di raggiungere la velocità massima stabilita dal piano. Vedi di seguito per i test in singole stanze.",
}